import { useTenantFeatureGates } from '@api/hooks/useTenantFeatureGates';
import { permissions } from '@app/permissions/permissions';
import usePermissions from '@app/permissions/usePermissions';
import { useMemo } from 'react';
import { TenantFeatureGatesEnum } from 'src/constants/tenantFeatureGates';
import { DIRECT_LINE } from 'src/constants/tenantSelection';

export const useTenantOutboundConfig = ({
  selectedTenantId,
  skip = false,
}: {
  selectedTenantId?: string;
  skip?: boolean;
}) => {
  const isPermissionToUseDID = usePermissions(
    [permissions.general.ACTION_CALL_OPTIONS.OUTBOUND_CALLS.DID_CREATE],
    'all',
  );
  const isTenantSelected = selectedTenantId !== DIRECT_LINE;

  const {
    data,
    loading: loadingCallerId,
    error,
  } = useTenantFeatureGates({
    tenantIds: selectedTenantId ? [selectedTenantId] : [],
    featureGateKeys: [
      TenantFeatureGatesEnum.OutgoingCallerId,
      TenantFeatureGatesEnum.EnableCustomOutboundCallerId,
    ],
    skip: skip || !isTenantSelected,
  });

  const outgoingCallerId = useMemo(() => {
    const outgoingCallerIdFeatureGate = data?.tenantFeatureGates.find(
      (featureGate) =>
        featureGate.key === TenantFeatureGatesEnum.OutgoingCallerId,
    );

    const value = outgoingCallerIdFeatureGate?.value;

    return value && 'stringValue' in value ? value.stringValue : undefined;
  }, [data]);

  const enableCustomOutboundCallerId = useMemo(() => {
    const outgoingCallerIdFeatureGate: any = data?.tenantFeatureGates.find(
      (featureGate) =>
        featureGate.key === TenantFeatureGatesEnum.EnableCustomOutboundCallerId,
    );
    const value = outgoingCallerIdFeatureGate?.value;
    return value?.boolValue;
  }, [data]);

  return {
    outgoingCallerId,
    enableCustomOutboundCallerId,
    isPermissionToUseDID,
    loadingCallerId,
    error,
  };
};
